import {PropertySpec, PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';

export class PropertyMap
{
    private _properties:Array<PropertySpec<any>> = [];
    private _nameToProperty:any = {};
    private _propertyNames:Array<string> = [];

    public add(property:PropertySpec<any>):void
    {
        this._properties.push(property);

        let name = property.name;
        this._nameToProperty[name] = property;
        this._propertyNames.push(name);
    }

    public findByName(name:PropName):PropertySpec<any>
    {
        let property:PropertySpec<any> = this._nameToProperty[name];
        return property || null;
    }

    public getProperties():Array<PropertySpec<any>>
    {
        return this._properties;
    }

    public getPropertyNames():Array<string>
    {
        return this._propertyNames;
    }
}
